import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function card(theme: Theme): ComponentStyle {
  return {
    componentName: 'card',
    baseStyle: {
      borderRadius: theme.sizes['0'],
      border: `solid 1px ${theme.colors.border}`
    },
    variants: {
      hypeCard: {
        background: theme.colors.hype.background80,
        padding: 0
      },
      dark: {
        background: theme.colors.hype.background100
      },
      chartKpiCard: {
        background: theme.colors.foreground,
        padding: `${theme.space['2xs']} ${theme.space['xs']}`
      },
      nested: {
        background: theme.colors.hype.background100,
        padding: `${theme.space['xs']} ${theme.space['s']}`
      },
      menuCard: {
        background: theme.colors.hype.background100,
        padding: `0 ${theme.space['l']}`,
        border: 'none',
        borderRadius: 'unset'
      }
    }
  };
}
